"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = require("./Icons");

var _Loader = require("./Loader");

var _constant = require("./constant");

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _signUpModule = _interopRequireDefault(require("../styles/sign-up.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _PhoneField = _interopRequireDefault(require("./PhoneField"));

var _otpVerification = _interopRequireDefault(require("./otp-verification"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SignUpForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignUpForm, _React$Component);

  function SignUpForm(props) {
    var _this;

    _classCallCheck(this, SignUpForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignUpForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "email", function (e) {
      _this.setState({
        email: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "firstName", function (e) {
      _this.setState({
        firstName: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "lastName", function (e) {
      _this.setState({
        lastName: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "password", function (e) {
      _this.setState({
        password: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "otpReceived", function () {
      _this.setState(function (prev) {
        return {
          otpReceived: !prev.otpReceived
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "signUp", function (e) {
      e.preventDefault();
      var formData = new FormData(e.target);
      var countryCode = formData.get("phone_country_code");
      var phone = formData.get("phone");
      formData.set("countryCode", countryCode);

      _this.setState({
        loading: true,
        phone: phone,
        countryCode: countryCode,
        error: false
      });

      fetch("".concat(_constant.API_ROOT, "sendotp.php"), {
        credentials: "same-origin",
        method: "POST",
        body: formData
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          _this.setState({
            otpReceived: true,
            loading: false,
            error: false
          });
        } else {
          _this.setState({
            error: true,
            loading: false
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _this.state = {
      error: false,
      loading: false,
      otpReceived: false,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      countryCode: "",
      password: ""
    };
    return _this;
  }

  _createClass(SignUpForm, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          loading = _this$state.loading,
          otpReceived = _this$state.otpReceived;

      if (otpReceived) {
        return _react.default.createElement(_otpVerification.default, {
          phone: this.state.phone,
          countryCode: this.state.countryCode,
          back: this.otpReceived,
          onSuccess: this.props.onSuccess
        });
      }

      var _this$state2 = this.state,
          firstName = _this$state2.firstName,
          lastName = _this$state2.lastName,
          email = _this$state2.email,
          password = _this$state2.password;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.backButton,
        onClick: this.props.back
      }, _react.default.createElement(_Icons.BackArrow, {
        width: "0.875rem"
      }), _react.default.createElement("span", null, "Back")), _react.default.createElement("div", {
        className: _baseModule.default.heading2
      }, "Sign up with email"), _react.default.createElement("form", {
        className: _baseModule.default.container,
        onSubmit: this.signUp
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, "User already exists. Try something else.")) : "", _react.default.createElement("input", {
        type: "email",
        name: "email",
        value: email,
        onChange: this.email,
        placeholder: "Email address",
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightEmailIcon),
        required: true
      }), _react.default.createElement("div", {
        className: _signUpModule.default.phoneFieldParent
      }, _react.default.createElement(_PhoneField.default, {
        defaultValue: this.state.phone,
        countryCode: this.state.countryCode,
        placeholder: "Contact number",
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightPhoneIcon),
        required: true,
        name: "phone"
      }), _react.default.createElement("p", null, _react.default.createElement(_Icons.GreenCircularTick, {
        width: "0.875rem",
        color: "#484848"
      }), _react.default.createElement("span", null, "Verification code will be sent to the provided contact."))), _react.default.createElement("input", {
        type: "text",
        name: "firstName",
        value: firstName,
        onChange: this.firstName,
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightNameIcon),
        placeholder: "First name",
        required: true
      }), _react.default.createElement("input", {
        type: "text",
        name: "lastName",
        value: lastName,
        onChange: this.lastName,
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightNameIcon),
        placeholder: "Last name",
        required: true
      }), _react.default.createElement("input", {
        type: "password",
        name: "password",
        value: password,
        onChange: this.password,
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightLockIcon),
        placeholder: "Password",
        required: true
      }), _react.default.createElement("div", {
        className: _signUpModule.default.disclaimer
      }, _react.default.createElement("p", null, "Your information is safe with us. We will send you booking related notifications, marketing promotions, special offers and trip recommendations via email.")), _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block),
        disabled: loading
      }, loading ? _react.default.createElement(_Loader.ButtonLoader, null) : "Sign up")), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.divider
      }), _react.default.createElement("p", {
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.light)
      }, "Already have an account with Trodly?", _react.default.createElement("span", {
        style: {
          marginLeft: "0.25rem"
        },
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.link, " ").concat(_baseModule.default.bold),
        onClick: this.props.login
      }, "Log in"))));
    }
  }]);

  return SignUpForm;
}(_react.default.Component);

var _default = SignUpForm;
exports.default = _default;